import CommunityAccessEnum from "src/api/graphql/__generated__/enums/CommunityAccessEnum";

type CommunityMemberAccessType = CommunityAccessEnum.Admin | CommunityAccessEnum.Participant;
const CommunityMemberAccessSet = new Set([
	CommunityAccessEnum.Admin,
	CommunityAccessEnum.Participant,
]);

const hasValidCommunityAccess = (
	access:
		| CommunityAccessEnum
		| null
		| undefined
		| { access?: CommunityAccessEnum | null | undefined },
): access is { access?: CommunityMemberAccessType } | CommunityMemberAccessType => {
	if (!access) return false;
	if (typeof access === "object") {
		if (!access.access) return false;
		return CommunityMemberAccessSet.has(access.access);
	}
	return CommunityMemberAccessSet.has(access);
};
export default hasValidCommunityAccess;
